import React from "react";

import BusinessNetworks from "../../../../components/Administration/CRM/BusinessNetworks";
import CrmShell from "../components/CrmShell";

/*
 * Page wrapper only.
 *
 * The BusinessNetworks implementation lives in:
 * src/components/Administration/CRM/BusinessNetworks
 */
const BusinessNetworksPage = () => (
  <CrmShell>
    <BusinessNetworks />
  </CrmShell>
);

export default BusinessNetworksPage;
